import React from 'react';
import PropTypes from 'prop-types';
import { CookiesProvider } from 'react-cookie';
import Helmet from 'react-helmet';
import { Protection } from '../components/protection';
import { Page } from './styles/index.style';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import { FooterModal } from '../components/footer-modal';

const propTypes = {
  children: PropTypes.func.isRequired,
};

/**
 * Global Page Layout
 * @param {object} param0 Incoming Props
 * @returns {XML} New Componet
 */
class Layout extends React.Component {
  /**
   * Constructor
   * @param {object} props Incoming Props
   */
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);
    this.showModal = this.showModal.bind(this);
    const {
      data: { contactModal, privacyModal, termsModal },
    } = props;
    const modals = {
      terms: termsModal ? termsModal.edges[0].node : null,
      privacy: privacyModal ? privacyModal.edges[0].node : null,
      contactus: contactModal ? contactModal.edges[0].node : null,
    };
    this.state = {
      modalData: null,
      showModal: false,
      modals,
    };
  }

  /**
   * Hide Modal
   */
  hideModal() {
    this.setState({ showModal: false });
  }

  /**
   * Show Modal
   * @param {string} label Content that should apear in the modal
   */
  showModal(label) {
    const {
      data: { contactModal, privacyModal, termsModal },
    } = this.props;
    const modals = {
      terms: termsModal ? termsModal.edges[0].node : null,
      privacy: privacyModal ? privacyModal.edges[0].node : null,
      contactus: contactModal ? contactModal.edges[0].node : null,
    };
    this.setState({
      showModal: true,
      modalData: modals[label],
    });
  }

  /**
   * Compiles JSX for a particular page
   * @return {JSX} JSX for page
   */
  renderPage() {
    const { data, children } = this.props;
    const { modalData, showModal, modals } = this.state;
    return (
      <Page>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[{ name: 'description', content: data.site.siteMetadata.description }]}
        />
        <Header teams={data.allContentfulTeam} />
        <main className="main">
          {children()}
          <Footer modals={modals} showModal={this.showModal} teams={data.allContentfulTeam} />
        </main>
        {showModal ? <FooterModal {...modalData} close={this.hideModal} /> : ''}
      </Page>
    );
  }

  /**
   * Renders the component
   * @returns {XML} Site layout
   */
  render() {
    const { data } = this.props;
    let isCloudfront = false;
    if (typeof window !== 'undefined' && window.location.href.indexOf('.cloudfront.net') > -1) {
      isCloudfront = true;
    }
    if (data.site.siteMetadata.passProtect === 'true' || isCloudfront) {
      return (
        <CookiesProvider>
          <Protection>{this.renderPage()}</Protection>
        </CookiesProvider>
      );
    }
    return <div>{this.renderPage()}</div>;
  }
}

Layout.propTypes = propTypes;

export default Layout;
// eslint-disable-next-line
export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        mailchimp
        description
        startDate
        passProtect
        showCities
      }
    }
    contactModal: allContentfulFooterModal(filter: { label: { eq: "contactus" } }) {
      edges {
        node {
          label
          title
          content {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    privacyModal: allContentfulFooterModal(filter: { label: { eq: "privacy" } }) {
      edges {
        node {
          label
          title
          content {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    termsModal: allContentfulFooterModal(filter: { label: { eq: "terms" } }) {
      edges {
        node {
          label
          title
          content {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
    allContentfulTeam(
      filter: { excludeFromSite: { ne: true } }
      sort: { fields: [sortOrder], order: ASC }
    ) {
      edges {
        node {
          urlSlug
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js